import { Link } from 'react-router-dom';

export default function Footer() {
    const SocialIcons = () => (
        <div className="flex gap-4">
            {/* Facebook */}
            <a
                href="https://www.facebook.com/kinetixpk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sky-800 dark:text-sky-400 hover:opacity-80 transition-opacity"
                aria-label="Facebook"
            >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
            </a>
            {/* Instagram */}
            <a
                href="https://www.instagram.com/kinetixpk/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sky-800 dark:text-sky-400 hover:opacity-80 transition-opacity"
                aria-label="Instagram"
            >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
            </a>
        </div>
    );

    return (
        <footer className="w-full border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 max-w-7xl mx-auto px-8 py-16">
                {/* Brand & Social – wider column (5/12) */}
                <div className="col-span-1 md:col-span-5">
                    <div className="text-xl font-bold text-slate-900 dark:text-white mb-6">Kinetix</div>
                    <p className="text-slate-500 dark:text-slate-400 font-['Inter'] text-sm leading-relaxed mb-8">
                        Elevating standard care through intentional sensory design and professional physical therapy
                        equipment.
                    </p>
                    <SocialIcons />
                </div>

                {/* Explore – (3/12) */}
                <div className="md:col-span-3 space-y-4">
                    <h5 className="font-bold text-sky-800 dark:text-sky-400 mb-6">Explore</h5>
                    <ul className="space-y-3 font-['Inter'] text-sm leading-relaxed">
                        <li><Link to="/" className="text-slate-500 dark:text-slate-400 hover:text-sky-600 dark:hover:text-sky-300 transition-all">Home</Link></li>
                        <li><Link to="/Categories" className="text-slate-500 dark:text-slate-400 hover:text-sky-600 dark:hover:text-sky-300 transition-all">Shop</Link></li>
                        <li><Link to="/BulkOrder" className="text-slate-500 dark:text-slate-400 hover:text-sky-600 dark:hover:text-sky-300 transition-all">Bulk Order</Link></li>
                    </ul>
                </div>

                {/* Company – (4/12) */}
                <div className="md:col-span-4 space-y-4">
                    <h5 className="font-bold text-sky-800 dark:text-sky-400 mb-6">Company</h5>
                    <ul className="space-y-3 font-['Inter'] text-sm leading-relaxed">
                        <li><Link to="/about" className="text-slate-500 dark:text-slate-400 hover:text-sky-600 dark:hover:text-sky-300 transition-all">About Kinetix</Link></li>
                        <li><Link to="/contactus" className="text-slate-500 dark:text-slate-400 hover:text-sky-600 dark:hover:text-sky-300 transition-all">Contact Us</Link></li>
                        <li><Link to="/terms-of-service" className="text-slate-500 dark:text-slate-400 hover:text-sky-600 dark:hover:text-sky-300 transition-all">Terms of Service</Link></li>
                        <li><Link to="/privacy-policy" className="text-slate-500 dark:text-slate-400 hover:text-sky-600 dark:hover:text-sky-300 transition-all">Privacy Policy</Link></li>
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-8 py-8 border-t border-slate-100 dark:border-slate-900 text-center">
                <p className="text-slate-500 dark:text-slate-400 font-['Inter'] text-xs">
                    © {new Date().getFullYear()} Kinetix Physiotherapy &amp; Sensory. All rights reserved.
                </p>
            </div>
        </footer>
    );
}